// import history from "history.js";
import axios from "axios";
import { get, post } from "../baseApi";
import { error, success } from "../../../views/utilities/Toast/Toast";
import { authHeaderWithToken, authHeaderWithOutToken } from "../AxiosHeader";
import UrlConfig from "./UrlConfig";



export const CAPA_REPORT_LOADING = "CAPA_REPORT_LOADING";
export const CAPA_REPORT_SUCCESS = "CAPA_REPORT_SUCCESS";
export const CAPA_REPORT_ERROR = "CAPA_REPORT_ERROR";

export const createOrUpdateCAPACorrectiveAction = (payload) => async (dispatch) => {
  let url = UrlConfig.createOrUpdateCAPACorrectiveActionTaken();

  dispatch({
    type: CAPA_REPORT_LOADING
  });

  let header = authHeaderWithToken();
  let res = await post(url, payload, header);
  if (res && res.status === 200) {
    //res && res.data
    success("Action updated successfully...");
    dispatch({
      type: CAPA_REPORT_SUCCESS,
      //data: user//res.data
    });
    return true;
  } else if (res && res.isAxiosError) {
    if (res.response && res.response.data && res.response.data.message) {
      error(res.response.data.message);
    } else {
      error("Error while Submitting Capa Report...");
    }
    dispatch({
      type: CAPA_REPORT_ERROR
      //payload: res.isAxiosError
    });
    return false;
  }
};

export const createOrUpdateCAPAPreventiveAction = (payload) => async (dispatch) => {
  let url = UrlConfig.createOrUpdateCAPAPreventiveActionTaken();

  dispatch({
    type: CAPA_REPORT_LOADING
  });

  let header = authHeaderWithToken();
  let res = await post(url, payload, header);
  if (res && res.status === 200) {
    //res && res.data
    success("Action updated successfully...");
    dispatch({
      type: CAPA_REPORT_SUCCESS,
      //data: user//res.data
    });
    return true;
  } else if (res && res.isAxiosError) {
    if (res.response && res.response.data && res.response.data.message) {
      error(res.response.data.message);
    } else {
      error("Error while Submitting Capa Report...");
    }
    dispatch({
      type: CAPA_REPORT_ERROR
      //payload: res.isAxiosError
    });
    return false;
  }
};
